import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import {
  ApplicationInsights,
  DistributedTracingModes,
  ITelemetryItem,
} from "@microsoft/applicationinsights-web";

import { trackCspViolations } from "./trackCspViolations.ts";

const DISABLED_CONNECTION_STRING = "InstrumentationKey=none;";

const APP_INSIGHTS_CONNECTION_STRING: string =
  import.meta.env.VITE_APP_INSIGHTS_CONNECTION_STRING ??
  DISABLED_CONNECTION_STRING;

const API_BASE_URI = import.meta.env.VITE_API_BASE_URI;

const apiHost = resolveApiHost(API_BASE_URI);
const disableTelemetry =
  APP_INSIGHTS_CONNECTION_STRING === DISABLED_CONNECTION_STRING;

const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
  // https://learn.microsoft.com/en-us/azure/azure-monitor/app/javascript-sdk-configuration
  config: {
    connectionString: APP_INSIGHTS_CONNECTION_STRING,
    extensions: [reactPlugin],
    enableAutoRouteTracking: true,
    autoTrackPageVisitTime: true,
    enableRequestHeaderTracking: true,
    enableResponseHeaderTracking: true,
    distributedTracingMode: DistributedTracingModes.W3C,
    // enable distributed tracing correlation with API
    enableCorsCorrelation: true,
    correlationHeaderDomains: apiHost ? [apiHost] : undefined,
    enableUnhandledPromiseRejectionTracking: true,
    disableTelemetry,
    isBeaconApiDisabled: true,
  },
});

if (!disableTelemetry) {
  appInsights.loadAppInsights();
  appInsights.addTelemetryInitializer((envelope: ITelemetryItem) => {
    envelope.tags = envelope.tags || {};
    envelope.tags["ai.cloud.role"] = "Frontend";
  });

  trackCspViolations(appInsights);
}

function resolveApiHost(uri: string | undefined): string | undefined {
  if (!uri) return undefined;
  try {
    return new URL(uri).host;
  } catch {
    return undefined;
  }
}

export { appInsights, reactPlugin };
